import React, { useState, useEffect, useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";

import { MultipleImages, TextImage, ImageTextBlend, MiniSlider } from '../../../components/PageHero'
import { ArraySections, ContentNavigation, ContentSearch } from '../../../components/PageContent'

import "./blog.css";

const toCamelCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word, index) => {
      if (index === 0) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');
};

const Blog = ({ data }) => {
  const datas = useStaticQuery(
    graphql`
      query {
        allContentfulBlogPosts(
          sort: { fields: publishDate, order: DESC }
          filter: { 
            isDraft: { ne: true }
            resourceType: { eq: "Blog Post" }
          }
        ) {
          nodes {
            createdAt
            isDraft
            isHeaderDark
            languagePreference
            publishDate
            title
            excerptContentOptions
            excerpt {
              raw
            }
            introTextStyling {
              fontSize
              lineHeight
              content {
                content
              }
            }
            outroTextStyling {
              fontSize
              lineHeight
              content {
                content
              }
            }
            intro{
              intro
            }
            blogBodyContent {
              textContent {
                textContent
              }
            }
            thumbnailImage {
              gatsbyImageData(width: 2400, quality: 100)
            }
            blogPostUrlSlug
            categories {
              title
            }
            parentCategory {
              categoryName
              slugId
            }
          }
        }
        allContentfulBlogCategories(
          sort: { fields: createdAt, order: ASC }
          filter: {
            title: { 
              nin: ["Cool Beans News", "Coffee Competitions", "Coffee Expos"] 
            }
          }
        ) {
          nodes {
            id
            title
            languagePreference
          }
        }
      }
    `
  );

  const [searchQuery, setSearchQuery] = useState('');
  const [isFixed, setIsFixed] = useState(false);
  const [topVisibility, setTopVisibility] = useState(false)
  const contentNavRef = useRef(null);
  const contentNavOffsetTop = useRef(0);

  useEffect(() => {
    if (contentNavRef.current) {
      contentNavOffsetTop.current = contentNavRef.current.offsetTop;
    }

    const handleScroll = () => {
      if (window.scrollY > contentNavOffsetTop.current) {
        setIsFixed(true);
        setTopVisibility(true);
      } else {
        setIsFixed(false);
        setTopVisibility(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  let pageHero = data.pageHero;
  let pageHeroTitle = data.headerPageTitle ? data.headerPageTitle : data.pageTitle;
  let PageHeroLayout = pageHero.multipleImages
    ? <MultipleImages heroContent={pageHero.multipleImages} pageHeroTitle={pageHeroTitle} />
    : pageHero.textImage ? <TextImage heroContent={pageHero.textImage} pageHeroTitle={pageHeroTitle} />
      : pageHero.imageTextBlend ? <ImageTextBlend heroContent={pageHero.imageTextBlend} pageHeroTitle={pageHeroTitle} />
        : pageHero.miniSlider ? <MiniSlider heroContent={pageHero.miniSlider} />
          : '';
  return (
    <div id='topBlog' className="relayout-blog" style={{
      backgroundImage: 'url(https://images.ctfassets.net/vhts96p7twn6/73K8HNzLBcxHM3dSVNYvvJ/5fcd76cee0fc21593388f8942eff148e/background_Blog.png)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    }}>
      {PageHeroLayout}
      <ContentNavigation ref={contentNavRef} isFixed={isFixed} landingSections={data.landingSections} toCamelCase={toCamelCase} pageLanguage={data.pageLanguage} />
      <ContentSearch onSearch={setSearchQuery} />
      <ArraySections landingSections={data.landingSections} searchQuery={searchQuery} toCamelCase={toCamelCase} datas={datas.allContentfulBlogPosts.nodes}/>
      {topVisibility && <a href='#topBlog' className='flex align-center justify-center fixed bottom-30 right-30 z-2 button button-top'><span className="sr-only">Scroll to Top</span></a>}
    </div>
  );
}

export default Blog;